module.exports = __webpack_public_path__ + "static/img/edition.7b6fdfcb.png";